var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app_footer"}},[_c('p',[_c('small',[_vm._v(" Current tab: "),_c('strong',[_vm._v(_vm._s(_vm.currentTab))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }